import React from "react";
import styles from "./DummyBrowserTabDesign.module.css";
import RefreshIcon from "@material-ui/icons/Refresh";
import HomeIcon from "@material-ui/icons/Home";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import classnames from "classnames";

export const DummyBrowserTabDesign = ({
  mobileDesign,
  browserUrl,
  faviconUrl,
  faviconHoverTitle,
  onRefreshClick,
  pageTitle,
}) => {
  const BrowserNavbarIcon = mobileDesign ? HomeIcon : RefreshIcon;

  return (
    <div className={styles.browserControls}>
      <div className={styles.browserTab}>
        <div className={styles.browserOuterCurveBg} />
        <div
          className={styles.previewFavicon}
          style={{
            backgroundImage: `url("${faviconUrl}")`,
          }}
          title={faviconHoverTitle}
        />
        {pageTitle}
      </div>
      <div className={styles.browserBar}>
        {!mobileDesign ? (
          <>
            <ArrowBackIcon title="Back" className={styles.browserIcon} />
            <ArrowForwardIcon title="Forward" className={styles.browserIcon} />
          </>
        ) : null}
        <BrowserNavbarIcon
          onClick={onRefreshClick}
          title="Refresh"
          className={`${styles.browserIcon} ${styles.refreshIcon}`}
        />
        <div className={classnames(styles.browserAddress, "ellipsis")}>
          {browserUrl}
        </div>
      </div>
    </div>
  );
};
